<script setup lang="ts">
/**
 * UiKitToaster — контейнер тостов. Монтируется один раз в корне (лейаут/страница).
 * Тосты добавляются через useKitToast().toast({...}). Figma: 3592-7897.
 */
import { useKitToast } from './toast'

type Placement = 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right'

const props = withDefaults(defineProps<{ placement?: Placement }>(), { placement: 'bottom-right' })

defineOptions({ name: 'UiKitToaster' })

const { toasts, remove } = useKitToast()

const POSITION: Record<Placement, string> = {
  'top-left': 'top-0 left-0 items-start flex-col',
  'top-center': 'top-0 left-1/2 -translate-x-1/2 items-center flex-col',
  'top-right': 'top-0 right-0 items-end flex-col',
  'bottom-left': 'bottom-0 left-0 items-start flex-col-reverse',
  'bottom-center': 'bottom-0 left-1/2 -translate-x-1/2 items-center flex-col-reverse',
  'bottom-right': 'bottom-0 right-0 items-end flex-col-reverse',
}
const enterFrom = computed(() => (props.placement.startsWith('top') ? '-translate-y-3' : 'translate-y-3'))
</script>

<template>
  <Teleport to="body">
    <div class="fixed z-[9999] flex gap-2 p-4 pointer-events-none w-full sm:w-auto" :class="POSITION[placement]">
      <TransitionGroup
        :enter-active-class="'transition duration-300 ease-out'"
        :enter-from-class="`opacity-0 ${enterFrom}`"
        leave-active-class="transition duration-200 ease-in absolute"
        leave-to-class="opacity-0 scale-95"
        move-class="transition-transform duration-200"
      >
        <UiKitToastItem
          v-for="t in toasts"
          :key="t.id"
          class="pointer-events-auto"
          :color="t.color"
          :variant="t.variant"
          :title="t.title"
          :description="t.description"
          :timeout="t.timeout"
          :closable="t.closable"
          :action="t.action"
          @action="t.action?.onClick(); remove(t.id)"
          @close="remove(t.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>
